import RadioOption from "@/entities/RadioOption";

const radioOptions: RadioOption[] = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
];

export default radioOptions;